export default {
    namespaced: true,
    state: {
        currentContext: null,
        navigationHistory: []
    },
    mutations: {
        SET_CONTEXT(state, context) {
            state.currentContext = context;
            state.navigationHistory.push(context);
        },
        CLEAR_CONTEXT(state) {
            state.currentContext = null;
            state.navigationHistory = [];
        }
    },
    actions: {
        setNavigationContext({ commit }, { path, parentLabel, grandParentLabel = null }) {
            commit('SET_CONTEXT', {
                path,
                parentLabel,
                grandParentLabel,
                timestamp: Date.now()
            });
        }
    },
    getters: {
        getCurrentContext: state => state.currentContext,
        getNavigationHistory: state => state.navigationHistory
    }
}